/* PlatformGridViewComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./PlatformGridViewRenderer.js");
const Registrations = require("../../../../../RegistrationNamespaces.js");

const DateColumn = require("./column_renderers/date/DateComponent.js");
const PagingPlatformFeed = require("./PagingOdmOsPlatformFeed.js");
const _ = require("lodash");

// OS Family options for grid column filtering
const OS_FAMILY_OPTIONS = {
    Windows: {
        name: "Windows",
        title: "Windows",
    },
    Debian: {
        name: "Debian",
        title: "Debian",
    },
};

class PlatformGridViewComponent extends EventEmitter {
    constructor(
        logger,
        gameEditor,
        steveUtils,
        userSession,
        storageFactory,
        solutionsManager,
        modalUserFeedback,
        licenseRestriction,
        di,
        OdmOsPlatform,
        ValueMap
    ) {
        super(di);
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._steveUtils = steveUtils;
        this._OdmOsPlatformEntityDef = OdmOsPlatform;
        this._userSession = userSession;
        this._modalUserFeedback = modalUserFeedback;
        this._solutionsManager = solutionsManager;
        this._solutionName =
            (solutionsManager.activeSolution && solutionsManager.activeSolution.name) || "";
        this._gridKey = _.camelCase(this._solutionName) + "_" + "platformExplorer";
        this._storageFactory = storageFactory;
        this._userGridData = undefined; //new UserGridData(this._gridKey);
        this._pagingPlatformFeed = undefined;
        this._renderer = new Renderer(this);
        this._explorerState = {
            selectedIds: [],
            //openedEditor: undefined,
            openedTabs: {},
            activeTab: undefined,
        };

        this.columns = undefined;
        this._sessionStorage = undefined; //new UserGridData(`${this._gridKey}_explorerState`, null, { storageKey: 'deviceExplorer_explorerState', storageType: 'session' });
        this._licenseRestriction = licenseRestriction;
        this._CDALicenseEnabled = this._hasAccessToCDA();
        this._di = di;
        this._ValueMap = ValueMap;
        this._manufacturerOptions = {};
        this._modelOptions = {};
        this._deviceTypeOptions = {};
    }

    get columnConfig() {
        if (this.columns) {
            return this.columns;
        }

        //creating a new static DEVICE_TYPES list to pass to filter dropdown for types (via options)

        this.columns = {
            grouping: {
                priority: 0,
                label: "Group",
                width: 220,
                shown: false,
                entityColumn: true,
                isGroupingColumn: true,
            },
            name: {
                label: "Name",
                groupable: false,
                shown: true,
                width: 200,
                priority: 1,
            },
            manufacturer: {
                label: "Manufacturer",
                groupable: true,
                shown: true,
                width: 150,
                priority: 2,
                options: this._manufacturerOptions || {},
            },
            deviceType: {
                label: "IoT Device Type",
                groupable: true,
                shown: true,
                width: 150,
                priority: 3,
                options: this._deviceTypeOptions || {},
            },
            model: {
                label: "Model",
                groupable: true,
                shown: true,
                width: 150,
                priority: 4,
                options: this._modelOptions || {},
            },
            osName: {
                label: "OS Name",
                groupable: true,
                shown: true,
                width: 150,
                priority: 5,
            },
            osFamily: {
                label: "OS Family",
                groupable: true,
                shown: true,
                width: 150,
                priority: 6,
                options: OS_FAMILY_OPTIONS,
            },
            osReleaseName: {
                label: "OS Release Name",
                groupable: true,
                shown: true,
                width: 150,
                priority: 7,
            },
            osVersion: {
                label: "OS Version",
                groupable: true,
                shown: true,
                width: 150,
                priority: 8,
            },
            machineArchitecture: {
                label: "Machine Architecture",
                groupable: true,
                shown: true,
                width: 150,
                priority: 9,
            },
            language: {
                label: "OS Language",
                groupable: true,
                shown: false,
                width: 150,
                priority: 10,
            },
            locale: {
                label: "Locale",
                groupable: true,
                shown: false,
                width: 150,
                priority: 11,
            },
            patchDepth: {
                label: "Patch Depth",
                groupable: false,
                shown: false,
                width: 120,
                dataType: "number",
                priority: 12,
            },
            linkCount: {
                label: "Images",
                groupable: false,
                shown: true,
                width: 100,
                dataType: "number",
                priority: 13,
            },
            instructionCount: {
                label: "Instructions",
                groupable: false,
                shown: true,
                width: 120,
                dataType: "number",
                priority: 14,
            },
            deviceCount: {
                label: "Devices",
                groupable: false,
                shown: true,
                width: 100,
                dataType: "number",
                priority: 15,
            },
            planCount: {
                label: "OS Plans",
                groupable: false,
                shown: true,
                width: 100,
                dataType: "number",
                priority: 16,
            },
            updatedBy: {
                label: "Updated By",
                groupable: false,
                shown: false,
                width: 150,
                priority: 17,
            },
            updatedOn: {
                label: "Updated On",
                columnRendererComponent: DateColumn,
                priority: 18,
            },
        };

        return this.columns;
    }

    get pagingFeed() {
        return this._pagingPlatformFeed;
    }

    get selectedRows() {
        return this._renderer.selectedRows;
    }

    get activeOrgId() {
        return this._userSession.activeOrganization.id;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        // this._solutionsManager.on("activeSolutionChanged", (this._onSolutionChanged = this._onSolutionChanged.bind(this)));
        this._storageFactory.on(
            "storageReady",
            (this._onStorageReady = this._onStorageReady.bind(this))
        );
        this._gameEditor.on(
            "EditorLaunched",
            (this._onEditorLaunched = this._onEditorLaunched.bind(this))
        );
        this._gameEditor.on(
            "EditorClosed",
            (this._onEditorClosed = this._onEditorClosed.bind(this))
        );
        this._gameEditor.on("ActiveTabChanged", this._onActiveTabChanged.bind(this));
    }

    _unregisterListeners() {
        // this._solutionsManager.removeListener("activeSolutionChanged", this._onSolutionChanged);
        if (this._storageFactory) {
            this._storageFactory.removeListener("storageReady", this._onStorageReady);
        }
        if (this._gameEditor) {
            // this._gameEditor.removeListener("EditorLaunched", this._onEditorLaunched);
            // this._gameEditor.removeListener("EditorClosed", this._onEditorClosed);
            // this._gameEditor.removeListener("ActiveTabChanged", this._onActiveTabChanged);
            this._gameEditor.removeAllListeners();
        }
    }

    _patchSorting(sorting) {
        // add second sorting order by name
        if (sorting && !sorting.name && this.columnConfig.name) {
            sorting.name = 1;
        }
    }

    _loadFieldOptions() {
        return this._ValueMap
            .loadValueMapByName(this._userSession.activeOrganization.id, "xdome")
            .then((vendorOsMapEntity) => {
                const fieldMappings = vendorOsMapEntity.valueMap;
                this._deviceTypeOptions = this._generateOptionsForField(fieldMappings.deviceType);
                this._manufacturerOptions = this._generateOptionsForField(
                    fieldMappings.manufacturer
                );
                this._modelOptions = this._generateOptionsForField(fieldMappings.model);
                return Promise.resolve();
            })
            .catch((err) => {
                this._logger.warn(
                    {error: err},
                    "PlatformGridViewComponent._loadFieldOptions() error - using empty options"
                );
                this._deviceTypeOptions = {};
                this._manufacturerOptions = {};
                this._modelOptions = {};
                return Promise.resolve();
            });
    }

    _generateOptionsForField(fieldMapObj) {
        if (!fieldMapObj) {
            return {};
        }
        const options = {};
        Object.keys(fieldMapObj)
            .filter((key) => fieldMapObj[key])
            .forEach((key) => {
                options[key] = {
                    name: key,
                    title: key,
                };
            });
        return options;
    }

    _registerFeedListeners() {}

    _unregisterFeedListeners() {}

    _registerUpdatedColumnListeners() {}

    _unregisterUpdatedColumnListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    whenModelIsReady(selectedSite) {
        return this.gameEditor
            .whenInitialized()
            .then(() => {
                this._userGridData = this._storageFactory.getRemoteStorageInstanceForEntityGrid(
                    "entity_grid_gl",
                    this._gridKey
                );
                this._sessionStorage = this._storageFactory.getSessionStorageInstance(
                    "entity_grid_gl",
                    `${this._gridKey}_explorerState`
                );
                this._explorerState = Object.assign(
                    {},
                    this._explorerState,
                    this._sessionStorage.getData()
                );
            })
            .then(() => {
                return this._loadFieldOptions();
            })
            .then(() => {
                return this._loadPlatformFeed();
            });
    }
    wasFeedPreviouslyInitialized() {
        return this._pagingPlatformFeed.wasPreviouslyInitialized();
    }

    whenFeedIsReady() {
        return this._pagingPlatformFeed.whenFeedReady();
    }

    get renderer() {
        return this._renderer;
    }

    get logger() {
        return this._logger;
    }

    shutdown() {
        this._unregisterFeedListeners();
        this._unregisterListeners();
        this._unregisterUpdatedColumnListeners();
        let shutdowns = [
            this._renderer.shutdown(),
            _.isUndefined(this._pagingPlatformFeed)
                ? Promise.resolve()
                : this._pagingPlatformFeed.shutdown(),
            _.isUndefined(this._sessionStorage)
                ? Promise.resolve()
                : this._sessionStorage.shutdown(),
        ];

        return Promise.all(shutdowns).then(
            () => {
                //this._gameEditor._unregisterDeviceExplorerListeners();
                this._gameEditor = undefined;
                this._renderer = undefined;
                this._steveUtils = undefined;
                this._explorerState = undefined;
                this._pagingPlatformFeed = undefined;
                this._DeviceEntityDef = undefined;
                this._userSession = undefined;
                this._modalUserFeedback = undefined;
                this._solutionsManager = undefined;
                this._solutionName = undefined;
                this._gridKey = undefined;
                this._userGridData = undefined;
                this._sessionStorage = undefined;
                this._logger = undefined;
                this._siteEntityDef = undefined;
                this._constructTypeEntityDef = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "PlatformGridViewComponent.shutdown() error");
            }
        );
    }

    get gameEditor() {
        return this._gameEditor;
    }

    get explorerState() {
        return this._explorerState;
    }

    set explorerState(val) {
        this.setExplorerState(val);
    }

    setExplorerState(val) {
        this._explorerState = val;
    }

    updateExplorerState(property, val) {
        if (val === undefined) {
            this._sessionStorage.removeData(property);
            _.unset(this._explorerState, property);
        } else {
            this._sessionStorage.setData(val, property);
            _.set(this._explorerState, property, val);
        }
    }

    resetSelection(newIds) {
        let selectedIds = [];

        if (newIds && newIds.length) {
            newIds.forEach((id) => {
                selectedIds.push(id);
            });
        }

        this.renderer._platformEntityGrid.setSelectedRows(selectedIds);
        this.updateExplorerState("selectedIds", {selectedRows: selectedIds});
        this.renderer._renderAvailableActions();
    }

    loadAndScrollTo(entityId) {
        let that = this;
        this.pagingFeed.on("RequestedEntityFound", handleRequestedEntityFound);
        this.pagingFeed._requestEntity(entityId);

        function handleRequestedEntityFound(index) {
            that.renderer._platformEntityGrid.renderer.scrollToTheRow(index);
            that.pagingFeed.removeListener("RefreshView", handleRequestedEntityFound);
        }
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onEditorClosed(tabId /*, editorParams*/) {
        //let editorsIds = editorParams.launchOptions.deviceIds;
        if (this._explorerState.openedTabs[tabId]) {
            delete this._explorerState.openedTabs[tabId];
            if (
                Object.keys(this._explorerState.openedTabs).length === 1 &&
                this._explorerState.openedTabs.sessionToken
            ) {
                delete this._explorerState.openedTabs.sessionToken;
            }
        }
        if (this._explorerState.activeTab === tabId) {
            if (!_.isEmpty(this._explorerState.openedTabs)) {
                let openedTabsIds = Object.keys(this._explorerState.openedTabs);
                this.updateExplorerState("activeTab", openedTabsIds[openedTabsIds.length - 1]);
            } else {
                this.updateExplorerState("activeTab", undefined);
            }
        }
        this.updateExplorerState("openedTabs", this._explorerState.openedTabs);
    }

    _onActiveTabChanged(tabId /*, editorParams*/) {
        if (this._explorerState.activeTab !== tabId) {
            this.updateExplorerState("activeTab", tabId);
        }
    }

    _onEditorLaunched(editorState, launchOpts) {
        if (!this._explorerState.openedTabs[launchOpts.id]) {
            let openedTab = Object.assign(editorState, launchOpts);
            this._explorerState.openedTabs[launchOpts.id] = openedTab;
            this.updateExplorerState("openedTabs", this._explorerState.openedTabs);
        }
        this.updateExplorerState("activeTab", launchOpts.id);
    }

    onUserSorted(sortData) {
        sortData = [].concat(sortData);
        let sort = {};

        sortData.forEach((sortData) => {
            if (!sortData || !sortData.sortColumn || !this.columnConfig[sortData.sortColumn]) {
                return;
            }
            const sortCriteria =
                this.columnConfig[sortData.sortColumn].valuePath ||
                this.columnConfig[sortData.sortColumn].path ||
                sortData.sortColumn;
            sort[sortCriteria] = sortData.sort === "asc" ? 1 : -1;
        });

        this._patchSorting(sort);

        this._pagingPlatformFeed.setSort(sort);
    }

    _onSolutionChanged(solution) {
        // whole pane will be reset, no need to make any action here
        this._solutionName = solution.name;
    }

    _onStorageReady() {}

    _onPropertiesUpdated(pristineProperties, before) {
        let updatedColumnKeys = pristineProperties.fields;
        let previousColumnKeys = before.fields;
        let editedColumn = Object.assign(
            {},
            ..._.reduce(
                updatedColumnKeys,
                (result, value, key) => {
                    return _.isEqual(value, previousColumnKeys[key])
                        ? result
                        : result.concat({
                              [key]: value,
                          });
                },
                []
            )
        );
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    async _establishImageServersFeed(orgId) {
        if (!orgId) {
            return;
        }
        const query = {};
        const fields = [
            "enabled",
            "name",
            "identifier",
            "ip",
            "status",
            "percentFull",
            "isMain",
        ].reduce((fields, field) => Object.assign(fields, {[field]: true}), {});

        const sort = {createdOn: 1};
        if (this._imageServersFeed) {
            await this._imageServersFeed.whenInitialized();
            await this._imageServersFeed.reestablishFeed(orgId, query, fields, sort);
        } else {
            this._imageServersFeed = await this._osImageServerEntity.startAscendOsImageServersFeed(
                orgId,
                query,
                fields,
                sort
            );
            this._registerImageServersFeedListeners(this._imageServersFeed);
        }

        return this._imageServersFeed;
    }

    _initStatusBar() {
        this._defaultDiOpts = {
            defaultInjectables: ["$teve.logger", "eventEmitter.eventEmitter"],
        };

        let diOpts = _.cloneDeep(this._defaultDiOpts) || {};
        diOpts.injectableOverrides = {
            //"gameEditor.gameEditor": this
            "eventEmitter.eventEmitter": this,
        };

        return this._di.createInstance(Registrations.DEVICE_EXPLORER_STATUS_BAR, diOpts);
    }

    _onImageServerFeedUpdate(feed) {
        this.emit("ImageServersUpdated", feed.getCacheAsArray());
    }

    _registerImageServersFeedListeners(feed) {
        const onFeedUpdate = _.debounce(this._onImageServerFeedUpdate.bind(this), 0);

        feed.on("ChangeFeedInitialized", (data, feed /*, reInit*/) => {
            onFeedUpdate(feed, "ChangeFeedInitialized");
        })
            .on("EntityInitialized", () => {
                onFeedUpdate(feed, "EntityInitialized");
            })
            .on("EntityPropertiesUpdated", (entity, patches, props, feed) => {
                onFeedUpdate(feed, "EntityPropertiesUpdated");
            })
            .on("EntityAdded", (entity, properties, feed) => {
                onFeedUpdate(feed, "EntityAdded");
            })
            .on("EntityRemoved", (entity, cause, feed) => {
                onFeedUpdate(feed, "EntityRemoved");
            })
            .once("ShutdownStarted", () => {
                onFeedUpdate.cancel();
                feed.removeListener("ChangeFeedInitialized", onFeedUpdate)
                    .removeListener("EntityInitialized", onFeedUpdate)
                    .removeListener("EntityPropertiesUpdated", onFeedUpdate)
                    .removeListener("EntityAdded", onFeedUpdate)
                    .removeListener("EntityRemoved", onFeedUpdate);
            });
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    async _loadPlatformFeed() {
        const basicFilterQuery = _.get(this._userGridData.getBasicSearchData(), "filterQuery", {});
        const advancedFilterQuery = this._userGridData.getAdvancedSearchData();

        const userSorting = this._userGridData.getSorting() || {};

        this._patchSorting(userSorting);
        let filterQuery = !_.isEmpty(advancedFilterQuery) ? advancedFilterQuery : basicFilterQuery;

        let _filter = JSON.parse(JSON.stringify(filterQuery));

        this._pagingPlatformFeed = new PagingPlatformFeed({
            feedKey: this._gridKey + "_feed",
            activeOrgId: this.activeOrgId,
            entityDef: this._OdmOsPlatformEntityDef,
            columnConfig: this.columnConfig,
            filter: _filter,
            sort: userSorting,
        });

        return this.whenFeedIsReady();
    }

    openPlatformInstanceEditor(ids, fullyQualifiedViewName) {
        const id = Array.isArray(ids) ? ids[0] : ids,
            fqn = fullyQualifiedViewName || Registrations.ODM_OS_PLATFORM_EDITOR_VIEW_DETAILS,
            OdmOsplatform = this._pagingPlatformFeed.getOdmOsPlatformEntityById(id),
            title = _.get(OdmOsplatform, "name", "");
        this._gameEditor.launchOdmOsPlatformEditor(
            {
                fqn,
            },
            {
                id,
                title,
            }
        );
    }

    openNetworkDiscoveryEditor(ids = [], openFromUrl = false) {
        let editorState = {
            fqn: Registrations.NETWORK_DISCOVERY_EDITOR_VIEW_DETAILS,
        };
        let launchOpts = {
            id: this.activeOrgId,
            title: "Network Discovery",
            type: "NetworkDiscovery",
            selectedDevice: ids || [],
            openFromURL: openFromUrl,
        };
        this._gameEditor.launchNetworkDiscoveryEditor(editorState, launchOpts);
    }

    getSelectedOdmOsPlatformIds() {
        const selectedIds = _.get(this._explorerState, "selectedIds", []);
        if (Array.isArray(selectedIds)) {
            return {selectedRows: selectedIds};
        }
        return selectedIds;
    }

    _hasAccessToCDA() {
        const hasPermission = !!_.get(this._userSession._userEntity, "authorizedActions").filter(
            (action) => action === "configDriftAndAuditAccess"
        ).length;
        const hasLicense = this._licenseRestriction.checkLicense("CDA");

        if (hasPermission && hasLicense) {
            return true;
        }
        return false;
    }

    _getOsPlanDataForAdvancedFilter(data) {
        let clonedData = _.clone(data);
        let newObj = {};
        for (let key in clonedData) {
            let value = {};
            value[key] = {
                name: key,
                title: clonedData[key],
            };
            newObj = Object.assign(newObj, value);
        }
        return newObj;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = PlatformGridViewComponent;

PlatformGridViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.utils",
    "$teve.userSession",
    "$teve.storageFactory",
    "$teve.solutionsManager",
    "$teve.ui.userFeedback",
    "$teve.licenseRestriction",
    "$teve.di",
    "$teve.entities.OdmOsPlatform",
    "$teve.entities.ValueMap",
];

PlatformGridViewComponent.$displayDetails = {
    type: "View",
    name: "",
    icon: "common.switch",
    shown: false,
    order: 1,
};
